import React, { useEffect, useState } from "react";
import AppRoutes from "./routes/AppRoutes";
import { AuthService } from "./services/auth.service";
import {
  getAuthToken,
  getAuthSession,
  setAuthSession,
  clearAllAuthState,
} from "./pages/AdminAuth/components/authStore";

export default function App() {
  const [bootstrapping, setBootstrapping] = useState(true);

  useEffect(() => {
    let alive = true;

    async function bootstrapAuth() {
      const token = getAuthToken();
      const storedSession = getAuthSession() || {};

      if (!token) {
        if (alive) setBootstrapping(false);
        return;
      }

      try {
        const res = await AuthService.me();

        if (!alive) return;

        const canOpenAdmin =
          !!res?.dashboardAccess?.canOpenAdminDashboard ||
          !!storedSession?.dashboardAccess?.canOpenAdminDashboard;

        const canOpenWarehouse =
          !!res?.dashboardAccess?.canOpenWarehouseDashboard ||
          !!storedSession?.dashboardAccess?.canOpenWarehouseDashboard;

        const storedCurrentDashboard = storedSession?.currentDashboard;
        const storedSelectedWarehouseId = storedSession?.selectedWarehouseId;

        let finalCurrentDashboard = res?.currentDashboard;
        let finalSelectedWarehouseId = res?.selectedWarehouseId;

        // IMPORTANT:
        // Refresh ke baad last opened dashboard preserve karo.
        if (storedCurrentDashboard === "warehouse" && canOpenWarehouse) {
          finalCurrentDashboard = "warehouse";
          finalSelectedWarehouseId =
            storedSelectedWarehouseId ||
            res?.selectedWarehouseId ||
            res?.warehouseAccess?.assignedWarehouseId ||
            null;
        } else if (storedCurrentDashboard === "admin" && canOpenAdmin) {
          finalCurrentDashboard = "admin";
          finalSelectedWarehouseId =
            res?.selectedWarehouseId ?? storedSelectedWarehouseId ?? null;
        } else {
          // fallback
          if (canOpenWarehouse && !canOpenAdmin) {
            finalCurrentDashboard = "warehouse";
            finalSelectedWarehouseId =
              storedSelectedWarehouseId ||
              res?.selectedWarehouseId ||
              res?.warehouseAccess?.assignedWarehouseId ||
              null;
          } else {
            finalCurrentDashboard = "admin";
            finalSelectedWarehouseId =
              res?.selectedWarehouseId ?? storedSelectedWarehouseId ?? null;
          }
        }

        setAuthSession({
          accessToken: token,
          admin: res?.admin,
          dashboardAccess: res?.dashboardAccess,
          warehouseAccess: res?.warehouseAccess,
          currentDashboard: finalCurrentDashboard,
          selectedWarehouseId: finalSelectedWarehouseId,
        });
      } catch (err) {
        console.error("Auth bootstrap failed:", err);
        clearAllAuthState();
      } finally {
        if (alive) setBootstrapping(false);
      }
    }

    bootstrapAuth();

    return () => {
      alive = false;
    };
  }, []);

  if (bootstrapping) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#fff7f8]">
        <div className="text-[15px] font-semibold text-[#d86a78]">
          Loading session...
        </div>
      </div>
    );
  }

  return <AppRoutes />;
}